module.exports = __webpack_public_path__ + "static/media/bodygaya_under_bodh_tree_with_monks.6753bf38.jpg";